import { useRef, useState } from 'react';
import { Button, Portal } from '@nazka/nazka.mapframe.components';
import { faClose } from '@fortawesome/pro-solid-svg-icons';

import NumberInput from '@App/components/NumberInput/NumberInput';

import { useOnClickOutside } from '@services/hooks.service';

import './edit-mobility-field-modal.styl';

function getErrorMessage(value, type) {
  if (value === null || value === undefined) {
    return '';
  }

  if (value === '') {
    return 'Gelieve een getal in te vullen';
  }

  if (Number(value < 0)) {
    return 'Het getal moet groter dan 0 zijn';
  }

  if ((type === 'int' && Number(value % 1 !== 0))) {
    return 'Het getal mag geen kommagetal zijn';
  }

  if (type === 'number') {
    const decimals = String(value).split('.')[1] || String(value).split(',')[1];

    if (decimals?.length > 2) {
      return 'Het getal mag maximaal 2 decimalen hebben';
    }
  }

  return '';
}

function EditMobilityFieldModal({
  field,
  onConfirm,
  onCancel,
  title,
}) {
  const [updatedValue, setUpdatedValue] = useState(field.value);

  const contentRef = useRef();

  useOnClickOutside(contentRef, onCancel);

  const errorMessage = getErrorMessage(updatedValue, field.dataType);

  return (
    <Portal>
      <div className="edit-mobility-field-modal">
        <div className="edit-mobility-field-modal__content" ref={contentRef}>
          <h3 className="edit-mobility-field-modal__content__title">
            {title}
            <Button
              layout="ghost"
              hover={false}
              icon={faClose}
              className="edit-mobility-field-modal__content__title__close"
              onClick={onCancel}
              color="black"
            />
          </h3>
          <p>
            {field.displayName}
          </p>
          <NumberInput 
            value={updatedValue}
            onChange={(value) => {
              setUpdatedValue(value);
            }}
            required
            type={field.dataType}
            placeholder={field.unit}
            error={errorMessage}
          />
          <Button
            className="edit-mobility-field-modal__content__button"
            onClick={() => {
              onConfirm(field.dataType === 'int' ? parseInt(updatedValue, 10) : parseFloat(updatedValue))
            }}
            disabled={!!errorMessage}
          >
            Opslaan
          </Button>
        </div>
      </div>
    </Portal>
  );
}

export default EditMobilityFieldModal;